import state from './state.ts';
import * as getters from './getters.ts';
import * as mutations from './mutations';
import * as actions from './actions';

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
